module.exports = __webpack_public_path__ + "img/4.c5f24e5b.png";